import { createFileRoute } from '@tanstack/react-router';
import { FullSizeSpinner } from '@/components/ui/FullSizeSpinner';

export const Route = createFileRoute('/(app)/org/$org/adaptive-planner/plan/$planId')({
  pendingComponent: FullSizeSpinner,
});
